@if (loading) {
  <div class="loader-overlay">
    <div class="custom-loading-overlay">
      <i class="custom-loader"></i>
      @if (loaderMessage()?.length) {
        <span class="delay-message">{{ loaderMessage() }}</span>
      } @else if (showTimeoutMessage) {
        <span class="delay-message">
          Taking longer than expected,
          <br />
          please try again later
        </span>
      } @else {
        <span class="delay-message">Loading data, Please wait...</span>
      }
    </div>
  </div>
}
